import { render, staticRenderFns } from "./topnavitem.vue?vue&type=template&id=236e48c7&"
import script from "./topnavitem.vue?vue&type=script&lang=js&"
export * from "./topnavitem.vue?vue&type=script&lang=js&"
import style0 from "./topnavitem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports